import React, {Component, useMemo, useState} from "react";
import {Route} from "react-router-dom";
/*
export default function AsyncComponentWrapper({myImport, children, ...props}) {
    const [Component, setComponent] = useState(React.Fragment);
    useMemo(() => {
        myImport().then(component => setComponent(component.default));
    }, []);
    return <Component {...props}>
        {children}
    </Component>
}
*/


export function RouteMax({path, component, props, importName, ...rest}) {
    console.log("maxprops1", rest)
    const asyncComponentMemorized = useMemo(() => (props2) => <AsyncComponentWrapper myImport={component} importName={importName}  {...props2}{...props}/>, [path])
    return <Route {...rest} path={path} component={asyncComponentMemorized}/>
}

export  class AsyncComponentWrapper extends Component {
    state = {
        component: null
    };

    async componentDidMount() {
        const imp = await this.props.myImport();

        this.setState({
            component: this.props.importName ? imp[this.props.importName] : imp.default
        });
    }

    render() {
        const C = this.state.component;

        return C ? <C {...{...this.props, myImport: undefined}} /> : null;
    }
}
